/*
 * Adds scroll shadow divs and an event listener to adjust shadow opacity
 * @param  {array} tableHeight     calculated Table Height
 */
export default function toolboxScrollShadow(toolbox) {
  const toolboxViewport = toolbox.querySelector('ul');
  const toolboxContainer = toolbox.querySelector('ul div');

  const shadowRight = document.createElement('div');
  const shadowLeft = document.createElement('div');

  // Reuse scroll shadow from table
  shadowRight.className = 'ag-scroll-shadow-right';
  shadowLeft.className = 'ag-scroll-shadow-left';
  shadowLeft.style.left = '-10px';

  toolboxViewport.appendChild(shadowRight);
  toolboxViewport.appendChild(shadowLeft);

  shadowLeft.style.opacity = 0;

  shadowRight.style.opacity =
    0 >= (toolboxContainer.scrollWidth - toolboxViewport.clientWidth) ? 0 : 1;

  toolboxContainer.addEventListener('scroll', () => {
    const scrollRight =
      (toolboxContainer.scrollWidth -
        toolboxContainer.scrollLeft - toolboxViewport.clientWidth);

    shadowRight.style.opacity = 1 < scrollRight / 20 ?
      1.0 : scrollRight / 20;
    shadowLeft.style.opacity = 1 < toolboxContainer.scrollLeft / 20 ?
      1.0 : toolboxContainer.scrollLeft / 20;
  });
}



// WEBPACK FOOTER //
// ./app/utils/ui/toolboxScrollShadow.js